import { render, staticRenderFns } from "./Adresboek.vue?vue&type=template&id=0413b735&scoped=true"
import script from "./Adresboek.vue?vue&type=script&lang=js"
export * from "./Adresboek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0413b735",
  null
  
)

export default component.exports